/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWatchlistCommand } from '../../models/create-watchlist-command';
import { WatchlistModelResult } from '../../models/watchlist-model-result';

export interface ApiWatchlistCreatePost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params {
      body?: CreateWatchlistCommand
}

export function apiWatchlistCreatePost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal(http: HttpClient, rootUrl: string, params?: ApiWatchlistCreatePost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<WatchlistModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiWatchlistCreatePost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=none;odata.streaming=true');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=minimal', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WatchlistModelResult>;
    })
  );
}

apiWatchlistCreatePost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal.PATH = '/api/watchlist/create';
